import { IconProps } from "src/shared/icons/interfaces/IconProps.interface"

function Orden(props: IconProps) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx={4} cy={4} r={4} fill="#5374AE" />
            <path
                fill="#fff"
                d="M5.767 4.508a.85.85 0 0 1 .16.015v-.015c0-.43-.182-.843-.51-1.16a2.029 2.029 0 0 0-1.257-.547v-.293h.16a.171.171 0 0 0 .114-.041.135.135 0 0 0 .047-.101.135.135 0 0 0-.047-.102.171.171 0 0 0-.114-.041h-.643a.171.171 0 0 0-.113.042.135.135 0 0 0-.047.1c0 .038.017.075.047.102.03.026.07.041.113.041h.161v.293c-.482.036-.93.231-1.258.548-.327.316-.51.73-.51 1.16v.014a.85.85 0 0 1 .161-.015h3.536ZM5.768 4.808H2.232a.514.514 0 0 0-.34.125.406.406 0 0 0-.142.303c0 .114.05.223.141.303.09.08.213.126.341.126h3.536c.128 0 .25-.045.34-.126.091-.08.142-.19.142-.303a.406.406 0 0 0-.141-.303.514.514 0 0 0-.341-.125Z"
            />
        </svg>
    )
}

export default Orden
